import { WarningRounded } from '@mui/icons-material';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import React from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { Button } from '@/components/Button';
import { isMac } from '@/utils/isMac';

import s from './ConfirmDialog.module.scss';

type ConfirmDialogProps = {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, onConfirm, onClose }) => {
  useHotkeys(isMac ? 'meta+enter' : 'alt+enter', (e) => {
    e.preventDefault();
    onConfirm();
  });

  return (
    <Dialog
      sx={{ '.MuiPaper-root': { width: '25%', borderRadius: '8px' } }}
      open={open}
      onClose={onClose}
    >
      <h1 className={s.title}>
        <WarningRounded sx={{ width: '22px' }} />
        Подтверждение
      </h1>

      <DialogContent>
        <div className={s.card}>
          <p>
            Ты логируешь часы за прошедший месяц — это согласовано с администратором проекта? Если
            нет, тебе нужно получить согласование.
          </p>
        </div>
      </DialogContent>
      <DialogActions>
        <div className={s.buttons}>
          <Button
            sx={{
              width: '45%',
              borderRadius: '8px',
            }}
            onClick={onClose}
            variant="outlined"
            color="primary"
          >
            <p>Отмена</p>
          </Button>
          <Button
            sx={{
              width: '45%',
              borderRadius: '8px',
              backgroundColor: 'var(--accent-color)',
              '&:hover': {
                backgroundColor: 'var(--dark-accent-color)',
              },
            }}
            onClick={onConfirm}
            variant="contained"
          >
            <p>Подтвердить</p>
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export { ConfirmDialog };
